
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button } from "react-bootstrap"
import BobbingIcon from '../common/BobbingIcon'
import "../../css/BobbingIcon.css"
import { ReactComponent as Icon } from "../../icon/no-internet-explorer.svg"
import "../../css/SMPLButton.css"

interface InternetExplorerModalProps {
  show: boolean
}

function InternetExplorerModal({ show }: InternetExplorerModalProps) {
  const { t } = useTranslation()

  return (
    <Modal show={show} centered backdrop="static">
      <Modal.Body className="p-4">
        <BobbingIcon horizontalOffset="-85px" verticalOffset="-70px">
          <Icon />
        </BobbingIcon>
        <h1>{t("internetExplorer.heading")}</h1>
        <p>{t("internetExplorer.text")}</p>
        <Button variant="smpl" href="https://help.simplebooth.com/en/articles/4408735-which-browsers-are-supported" target="_blank">{t("internetExplorer.help")}</Button>
      </Modal.Body>
    </Modal>
  )
}

export default InternetExplorerModal
